import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';
import { CacheService } from './cache.service';
import { DIMBO_CONSTANT } from '../utils/constant';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class SagaiService {
  domain: string;

  constructor(
    private http: HttpClient,
    private apiconfig: AppConfig,
    private cacheService: CacheService,
    private httpservice: HttpService
  ) {
    let apipath = '';
    if (this.apiconfig.mpsaFlag === 'N') {
      apipath = location.protocol + '//' + this.apiconfig.apiUrl;
    }

    this.domain = apipath + this.apiconfig.apiPath;
  }

  /**
   * Calls the backend service to get the goodwill acknowledgment for the given vehicle.
   * @param vin Vehicle Identification Number
   * @param mileage Vehicle mileage
   * @param unit The unit of the mileage (km, miles, etc.)
   * @param partReference Part reference
   * @param rrdiCode RRDI code
   * @param brand Vehicle brand
   * @returns Observable with the response from the backend API
   */
  getGoodwillAcknowledgment(
    vin: string,
    mileage: number,
    unit: string,
    partReference: string,
    rrdiCode: string,
    brand: string
  ): Observable<any> {
    // Retrieve the token from the cache
    const token = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_TOKEN);

    // Construct the query parameters
    const params = {
      vin: vin,
      mileage: mileage.toString(),
      unit: unit,
      partReference: partReference,
      rrdiCode: rrdiCode,
      brand: brand,
     // sourceApplication: 'DIMBO_UI' // Assuming this is the source application
    };

    // Construct the headers with the token
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
      'Content-Type': 'application/json'
    });

    const url = `${this.domain}/abacusDetails`;
    return this.httpservice.get(url, { params: params, headers: headers });
  }

  getAbacusDetails(mileage: any, unit: any, partReference: any, rrdiCode: any, brand: any, param: any) {
    let vin = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
    let finalURL = this.domain + '/abacusDetails/' + vin + '/mileage/' + mileage + '/unit/' + unit + '/partReference/' + partReference + '/rrdiCode/' + rrdiCode + '/brand/' + brand;

    return this.httpservice.postWithObserve(finalURL, param);
  }
}